import type { ChatMedia } from "@stockline/shared/types/ai/chat-media"
import type { OfflineResourceConfig } from "../../../types"
import { CHAT_MEDIA_TABLE } from "./db"

export const chatMediaConfig: OfflineResourceConfig<ChatMedia> = {
  name: "chat-media",
  // STK-1324: deferred, non-blocking -- hydrated via the SSE replay handshake
  // (cursor=0 full-table replay) AFTER readiness, not the cold-start waves.
  tier: "background",
  endpoints: {
    full: "/api/v2/chat-media",
    delta: "/api/v2/chat-media/changes",
    push: "/api/v2/chat-media/changes",
  },
  tableName: CHAT_MEDIA_TABLE,
  primaryKey: "id",
  indexes: {
    sessionId: "sessionId",
    messageId: "messageId",
    companyId: "companyId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
